import { Injectable, OnDestroy } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

const DESKTOP_MIN_WIDTH_PX = 568;
const DESKTOP_QUERY = `(min-width: ${DESKTOP_MIN_WIDTH_PX}px)`;

@Injectable({
  providedIn: 'root',
})
export class CheckDesktopService implements OnDestroy {
  private isDesktopSource: BehaviorSubject<boolean>;
  isDesktop: Observable<boolean>;

  private destroy$ = new Subject<void>();

  constructor(private breakpointObserver: BreakpointObserver) {
    this.isDesktopSource = new BehaviorSubject<boolean>(this.breakpointObserver.isMatched(DESKTOP_QUERY));
    this.isDesktop = this.isDesktopSource.asObservable();

    this.breakpointObserver
      .observe([DESKTOP_QUERY])
      .pipe(takeUntil(this.destroy$))
      .subscribe((state) => {
        this.isDesktopSource.next(state.matches);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
